export default {
    props: {
        virtualItemHeight: {
            type: Number,
            kComposite: 'virtual.itemHeight'
        }, 
        virtualMapValueTo: {
            type: String,
            kComposite: 'virtual.mapValueTo'
        }, 
        virtualValueMapper: {
            type: Function,
            kComposite: 'virtual.valueMapper'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/Common/Virtual.js